import React, { useEffect, useState } from 'react';
import classes from "./HomePage.module.css";
import { getGamesApi, loginApi } from '../Http/http';

import { Swiper, SwiperSlide } from "swiper/react";
import {
    Autoplay,
    EffectCoverflow,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-cube";
import { FaBarsStaggered, FaXmark } from "react-icons/fa6";
import Drawer from '../Components/Drawer';
import Loader from '../Components/Loader';
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const HomePage = () => {
    const [loading, setLoading] = useState(true);
    const [games, setGames] = useState([]);
    const [data, setData] = useState([]);

    const [drawer, setDrawer] = useState(false);
    const navigate = useNavigate();

    const checkSubscription = async () => {
        try {
            const response = await axios.post(`${loginApi}`, {
                msisdn: Cookies.get("msisdn")
            });
            console.log(response, 'response---');
        } catch (error) {
            if (error?.response?.status == 400) {
                Cookies.remove("msisdn");
                navigate("/");
            }
            else if (error?.response?.status === 500) {
                toast.error("Something went wrong on the server. Please try again later.");
            } else {
                console.log(error, 'erro---');
                toast.error("Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        if (Cookies.get('msisdn')) {
            checkSubscription();
        }
        else {
            navigate("/");
        }
    }, []);


    const fetchGames = async () => {
        try {
            setLoading(true);
            const response = await getGamesApi();
            setGames(response?.data?.result);

            // Filter out invalid entries
            const validGames = response?.data?.result.filter(
                (game) => game.name && game.category
            );

            // Group by category
            const categoryMap = {};
            validGames.forEach((game) => {
                if (!categoryMap[game.category]) {
                    categoryMap[game.category] = [];
                }
                categoryMap[game.category].push(game);
            });

            // Convert to array format
            const grouped = Object.keys(categoryMap).map((cat) => ({
                category: cat,
                data: categoryMap[cat],
            }));

            setData(grouped);
            setLoading(false);

        } catch (error) {
            setLoading(false);
            console.log(error, 'error---');
        }
    }

    console.log({ data }, 'data...');
    useEffect(() => {
        fetchGames();
    }, []);

    const handleNavigate = (link) => {
        window.location.href = link;
    }

    return (
        <>

            {loading ? <Loader /> : (
                <main className={classes.main}>
                    <div className={classes.header}>
                        <div className={classes.nav}>
                            <img src="/assets/logo.gif" alt="logo" className={classes.nav_logo} />

                            <div className={classes.nav_items}>
                                <button
                                    type="button"
                                    className={`${classes.nav_item}`}
                                    onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}
                                >
                                    Home
                                </button>

                                <button
                                    type="button"
                                    className={classes.nav_item}
                                    onClick={() => document.getElementById('trending')?.scrollIntoView({ behavior: 'smooth' })}
                                >
                                    Trending
                                </button>

                                <button
                                    type="button"
                                    className={classes.nav_item}
                                    onClick={() => document.getElementById('action')?.scrollIntoView({ behavior: 'smooth' })}
                                >
                                    Action
                                </button>

                                <button
                                    type="button"
                                    className={classes.nav_item}
                                    onClick={() => document.getElementById('adventure')?.scrollIntoView({ behavior: 'smooth' })}
                                >
                                    Adventure
                                </button>

                                <button
                                    type="button"
                                    className={classes.nav_item}
                                    onClick={() => document.getElementById('arcade')?.scrollIntoView({ behavior: 'smooth' })}
                                >
                                    Arcade
                                </button>

                                <button
                                    type="button"
                                    className={classes.nav_item}
                                    onClick={() => document.getElementById('general')?.scrollIntoView({ behavior: 'smooth' })}
                                >
                                    General
                                </button>

                                <button
                                    type="button"
                                    className={classes.nav_item}
                                    onClick={() => document.getElementById('puzzle')?.scrollIntoView({ behavior: 'smooth' })}
                                >
                                    Puzzle
                                </button>
                            </div>

                            <button type="button" className={classes.menu_button}
                                onClick={() => setDrawer((prevValue) => !prevValue)}
                            >
                                {drawer ? <FaXmark className={classes.menu_icon} /> : (
                                    <FaBarsStaggered className={classes.menu_icon} />
                                )}
                            </button>
                        </div>
                    </div>
                    <div className={classes.landing_page} id="home">
                        <div className={classes.landing_page_content}>
                            <h6 className={classes.landing_page_date}>
                                Best of {new Date().getFullYear()}
                            </h6>

                            <h2 className={classes.landing_page_title_1}>
                                World Class
                            </h2>
                            <h3 className={classes.landing_page_title_2}>Gaming</h3>

                            <a className={classes.explore_btn}>
                                Explore Games
                            </a>
                        </div>
                    </div>

                    <section className={classes.trending_games_section}
                        id="trending"
                    >
                        <div className={classes.container}>
                            <h4 className={classes.title}>Trending</h4>

                            <div className={classes.grid_containers}>
                                {games?.slice(0, 6)?.map((item, index) => {
                                    return (
                                        <div className={classes.grid_item_container} key={index}
                                            onClick={() => {
                                                handleNavigate(item?.game_url)
                                            }}

                                        >
                                            <div className={classes.grid_item_image_container}>
                                                <img src={item?.img_url} alt={item?.name} className={classes.grid_item_image} />
                                            </div>

                                            <div className={classes.grid_item_description}>
                                                <p className={classes.grid_item_title}>{item?.name}</p>
                                                <button type="button" className={classes.play_btn}>
                                                    Play
                                                </button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </section>

                    <section className={classes.category_games_section}
                        id="general"

                    >
                        <div className={classes.container}>
                            <h4 className={classes.title}>General</h4>

                            <div className={classes.carousel_section}>
                                {data &&
                                    <Swiper
                                        modules={[
                                            Autoplay,
                                            // EffectCoverflow,
                                        ]}
                                        loop
                                        effect={"coverflow"}
                                        coverflowEffect={{
                                            slideShadows: false,
                                            rotate: 40
                                        }
                                        }
                                        spaceBetween={40}
                                        slidesPerView={3}
                                        breakpoints={{
                                            0: {
                                                slidesPerView: 1, // for screen width 0–800px
                                            },
                                            801: {
                                                slidesPerView: 3, // for screen width >800px
                                            },
                                        }}
                                        // navigation
                                        autoplay={{
                                            delay: 500,
                                            disableOnInteraction: false,
                                        }}
                                        // pagination={{ clickable: true }}
                                        // scrollbar={{ draggable: true }}
                                        onSwiper={(swiper) => null}
                                        onSlideChange={() => null}
                                    >
                                        {data && data?.filter(item => item?.category == "General")?.[0]?.data.map((dataItem, index) => {
                                            console.log(data, 'diii');
                                            return (
                                                <SwiperSlide>
                                                    <div className={classes.grid_item_container_2} key={index}
                                                        onClick={() => {
                                                            handleNavigate(dataItem?.game_url)
                                                        }}
                                                    >
                                                        <div className={classes.grid_item_image_container}>
                                                            <img src={dataItem?.img_url} alt={dataItem?.name} className={classes.grid_item_image} />
                                                        </div>

                                                        <div className={classes.grid_item_description}>
                                                            <p className={classes.grid_item_title}>{dataItem?.name}</p>
                                                            <button type="button" className={classes.play_btn}>
                                                                Play
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {/* <div
                                                className={classes.quiz_card}
                                                key={data?.id}
                                            >
                                                <div className={classes.quiz_image}>
                                                    <img
                                                        className={classes.image}
                                                        alt={data?.name}
                                                        src={data?.img_url}
                                                    />
                                                </div>
                                                <h3 className={classes.text}>{data.name}</h3>
                                            </div> */}
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                }
                            </div>
                        </div>
                    </section>

                    <section className={classes.trending_games_section}
                        id="action"

                    >
                        <div className={classes.container}>
                            <h4 className={classes.title}>Action</h4>

                            <div className={classes.grid_containers}>
                                {data && data?.filter(item => item?.category == "Action")?.[0]?.data.map((dataItem, index) => {
                                    return (
                                        <div className={classes.grid_item_container} key={index}
                                            onClick={() => {
                                                handleNavigate(dataItem?.game_url)
                                            }}
                                        >
                                            <div className={classes.grid_item_image_container}>
                                                <img src={dataItem?.img_url} alt={dataItem?.name} className={classes.grid_item_image} />
                                            </div>

                                            <div className={classes.grid_item_description}>
                                                <p className={classes.grid_item_title}>{dataItem?.name}</p>
                                                <button type="button" className={classes.play_btn}>
                                                    Play
                                                </button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </section>

                    <section className={classes.trending_games_section}
                        id="adventure"

                    >
                        <div className={classes.container}>
                            <h4 className={classes.title}>Adventure</h4>

                            <div className={classes.grid_containers}>
                                {data && data?.filter(item => item?.category == "Adventure")?.[0]?.data.map((dataItem, index) => {
                                    return (
                                        <div className={classes.grid_item_container} key={index}
                                            onClick={() => {
                                                handleNavigate(dataItem?.game_url)
                                            }}
                                        >
                                            <div className={classes.grid_item_image_container}>
                                                <img src={dataItem?.img_url} alt={dataItem?.name} className={classes.grid_item_image} />
                                            </div>

                                            <div className={classes.grid_item_description}>
                                                <p className={classes.grid_item_title}>{dataItem?.name}</p>
                                                <button type="button" className={classes.play_btn}>
                                                    Play
                                                </button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </section>

                    <section className={classes.trending_games_section}
                        id="arcade"

                    >
                        <div className={classes.container}>
                            <h4 className={classes.title}>Arcade</h4>

                            <div className={classes.grid_containers}>
                                {data && data?.filter(item => item?.category == "Arcade")?.[0]?.data.map((dataItem, index) => {
                                    return (
                                        <div className={classes.grid_item_container} key={index}
                                            onClick={() => {
                                                handleNavigate(dataItem?.game_url)
                                            }}
                                        >
                                            <div className={classes.grid_item_image_container}>
                                                <img src={dataItem?.img_url} alt={dataItem?.name} className={classes.grid_item_image} />
                                            </div>

                                            <div className={classes.grid_item_description}>
                                                <p className={classes.grid_item_title}>{dataItem?.name}</p>
                                                <button type="button" className={classes.play_btn}>
                                                    Play
                                                </button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </section>

                    <section className={classes.trending_games_section}
                        id="puzzle"

                    >
                        <div className={classes.container}>
                            <h4 className={classes.title}>Puzzle</h4>

                            <div className={classes.grid_containers}>
                                {data && data?.filter(item => item?.category == "Puzzle")?.[0]?.data.map((dataItem, index) => {
                                    return (
                                        <div className={classes.grid_item_container} key={index}
                                            onClick={() => {
                                                handleNavigate(dataItem?.game_url)
                                            }}
                                        >
                                            <div className={classes.grid_item_image_container}>
                                                <img src={dataItem?.img_url} alt={dataItem?.name} className={classes.grid_item_image} />
                                            </div>

                                            <div className={classes.grid_item_description}>
                                                <p className={classes.grid_item_title}>{dataItem?.name}</p>
                                                <button type="button" className={classes.play_btn}>
                                                    Play
                                                </button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </section>


                    <Drawer drawer={drawer} setDrawer={setDrawer} />
                </main>
            )}
        </>

    )
}

export default HomePage